__turbopack_context__.v({
  "inboxIcon": "jYi2qa_inboxIcon",
});
